// Styles
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
import "@/variable.scss";
// Vuetify
import { createVuetify } from "vuetify";
import { mdi } from "vuetify/iconsets/mdi";
import { aliases, fa } from "vuetify/iconsets/fa";

export default createVuetify({
  theme: {
    defaultTheme: "myCustomTheme",

    themes: {
      myCustomTheme: {
        dark: false,

        colors: {
          primary: "#3f51b5",

          secondary: "#9C27b0",

          accent: "#9C27b0",

          info: "#00CAE3",
          dark: "#222222",
        },
      },
    },
    icons: {
      defaultSet: "fa",
      aliases,
      sets: {
        fa,
        mdi,
      },
    },
  },
});
// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
